import React, { useState } from 'react';
import OrderTicketUserList from '../components/order_ticket_user_list';
import OrderAddOnList from '../components/order_add_on_list';
import { useSelector } from 'react-redux';
import PurchaseButton from '../components/purchase_button';
import { Checkbox, Col, Divider, Row, Space, Radio } from 'antd';
import PromoCode from '../components/promo_code';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import PurchaseTaxes from '../components/purchase_taxes';
import ticketService from '../../../services/ticketing/ticket.service';
import numberHelper from '../../../helpers/functions/number.helper';
import PromoCodeDefault from '../components/promo_code_default';
import OrderInsuranceList from "../components/order_insurance_list";

const MobilePurchaseSummary = ({park, amount}) => {
    const ticketRedux = useSelector(state => state.ticket);
    const purchaseRedux = useSelector(state => state.purchase);
    const currency = ticketRedux?.park?.currency?.symbol;
    const { innerHeight } = window;
    const is_item_length = (purchaseRedux?.ticket_users?.length > 0 || purchaseRedux?.add_ons?.length > 0);   
    const [paymentMethod, setPaymentMethod] = useState('FIUU');

    const melonAmount = park?.melon_exchange_rate 
    ? Number((amount?.total_amount * park?.melon_exchange_rate).toFixed(2)) 
    : 0;
    return (
        <>
            {/* <div style={{height: (innerHeight * 0.6),}}> */}
            <div style={{height: ('calc(100% - 240px)'),}}>
                <div
                className='summary-cart-items scroll-item' 
                style={{
                    overflowY:'auto',
                    flexGrow : 1, 
                    maxHeight: 'calc(100%)',
                    height : (is_item_length ? 'auto' : '100%')
                }}
                >
                {
                    (is_item_length) ?
                    (
                        <>
                            <OrderTicketUserList discount_ticket_users={amount?.discount_ticket_users} />
                            <Divider style={{ margin : 0, }} />
                            <OrderAddOnList discount_add_ons={amount?.discount_add_ons} />
                        </>
                    )
                    :
                    (
                        <>
                            <div style={{display:'flex', alignItems:'center', justifyContent:'center', height:'100%'}}>
                                <span style={{color:'#6f7287'}}>No Item Added</span>
                            </div>
                        </>
                    )
                }
                </div>
            </div>

            <div className='purchase-modal-footer' style={{textAlign:'left', padding:'12px 24px', position:'unset', width:'auto', maxHeight:240}}>
				<div style={{ paddingBottom: '10px' }}>
					<OrderInsuranceList />
				</div>
                <Space size={4} style={{width:'100%'}} direction='vertical'>
                    <div>
                        {
                            ticketRedux?.default_promo_code ?
                            (
                                <>
                                    <PromoCodeDefault />
                                </>
                            )
                            :
                            (
                                <>
                                    <PromoCode />
                                </>
                            )
                        }
                    </div>

                    <div style={{marginTop:8,}}>
                        <EntranceMotion>
                            <div style={{ display:'flex', alignItems:'center', }}>
                                <div style={{ textAlign:'right'}}>
                                    <span style={{color:'var(--secondary-text-color)'}}>Sub Total</span>
                                </div>
                                <div style={{marginLeft:'auto'}}>
                                    <div>
                                        <span className='ticket-label'>
                                            {`${currency}${numberHelper.commaNumber(amount?.sub_total)}`}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display:'flex', alignItems:'center', }}>
                                <div>
                                    <div style={{ textAlign:'right'}}>
                                        <span style={{color:'var(--secondary-text-color)'}}>Discount</span>
                                    </div>
                                </div>
                                <div style={{marginLeft:'auto'}}>
                                    <div>
                                        <span className='ticket-label' style={{ color : 'var(--main-color)'}}>
                                            {`-${currency}${numberHelper.commaNumber(amount?.discount_amount)}`}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </EntranceMotion>
                    </div>
                    
                    <div>
                        <PurchaseTaxes park_taxes={park?.park_taxes} taxes={amount?.taxes} />
                    </div>

                    <div style={{ display:'flex', alignItems:'center' }}>
                        <div>
                            <div style={{ textAlign:'right'}}>
                                <span style={{color:'var(--secondary-text-color)'}}>Total</span>
                            </div>
                        </div>
                        <div style={{marginLeft:'auto'}}>
                            <div>
                                <span className='ticket-label' style={{fontSize:20, fontWeight:500}}>
                                    {`${currency}${numberHelper.commaNumber(amount?.total_amount)}`}
                                </span>
                            </div>
                        </div>
                    </div>
                    {park?.enable_pay_with_ewallet === true && (
                        <div style={{marginTop:12}}>
                            <div style={{marginBottom:8}}>
                                <span style={{fontSize:13, fontWeight:500, color:'var(--secondary-text-color)'}}>
                                    Payment Method
                                </span>
                            </div>
                            <Radio.Group 
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                disabled={!is_item_length}
                                style={{width:'100%'}}
                            >
                                <div style={{display:'flex', gap:'8px', width:'100%'}}>
                                    {/* Fiuu Option - Left Side */}
                                    <div 
                                        style={{
                                            flex: 1,
                                            border: paymentMethod === 'FIUU' ? '2px solid var(--main-color)' : '1px solid #d9d9d9',
                                            borderRadius: 6,
                                            padding: '8px',
                                            cursor: is_item_length ? 'pointer' : 'not-allowed',
                                            backgroundColor: paymentMethod === 'FIUU' ? 'var(--lighten-main-color)' : '#fff',
                                            transition: 'all 0.3s ease',
                                            opacity: !is_item_length ? 0.6 : 1,
                                        }}
                                        onClick={() => is_item_length && setPaymentMethod('FIUU')}
                                    >
                                        <Radio value="FIUU" style={{width:'100%'}}>
                                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center'}}>
                                                <img src="/fiuu-card.png" alt="Fiuu" style={{width:'20px', height:'20px', marginBottom:2, display:'block'}} />
                                                <div style={{
                                                    fontSize:12, 
                                                    fontWeight:500,
                                                    color: paymentMethod === 'FIUU' ? 'var(--main-color)' : 'var(--main-text-color)',
                                                    marginBottom:2
                                                }}>
                                                    Fiuu
                                                </div>
                                                <div style={{fontSize:9, color:'var(--secondary-text-color)', lineHeight:1.2}}>
                                                    Card & Banking
                                                </div>
                                            </div>
                                        </Radio>
                                    </div>

                                    {/* Melon Option - Right Side */}
                                    <div 
                                        style={{
                                            flex: 1,
                                            border: paymentMethod === 'MELON' ? '2px solid var(--main-color)' : '1px solid #d9d9d9',
                                            borderRadius: 6,
                                            padding: '8px',
                                            cursor: is_item_length ? 'pointer' : 'not-allowed',
                                            backgroundColor: paymentMethod === 'MELON' ? 'var(--lighten-main-color)' : '#fff',
                                            transition: 'all 0.3s ease',
                                            opacity: !is_item_length ? 0.6 : 1,
                                        }}
                                        onClick={() => is_item_length && setPaymentMethod('MELON')}
                                    >
                                        <Radio value="MELON" style={{width:'100%'}}>
                                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center'}}>
                                                <img src="/logo192.png" alt="Melon" style={{width:'20px', height:'20px', marginBottom:2, display:'block'}} />
                                                <div style={{
                                                    fontSize:12, 
                                                    fontWeight:500,
                                                    color: paymentMethod === 'MELON' ? 'var(--main-color)' : 'var(--main-text-color)',
                                                    marginBottom:2
                                                }}>
                                                    Melon
                                                </div>
                                                <div style={{fontSize:9, color:'var(--secondary-text-color)', lineHeight:1.2}}>
                                                {melonAmount > 0 
                                                        ? `E-Wallet: ${numberHelper.commaNumber(melonAmount)} Melons`
                                                        : 'E-Wallet'
                                                    }
                                                    {melonAmount > 0 
                                                        ? `E-Wallet: ${numberHelper.commaNumber(melonAmount)} Melons`
                                                        : 'E-Wallet'
                                                    }
                                                </div>
                                            </div>
                                        </Radio>
                                    </div>
                                </div>
                            </Radio.Group>

                            {/* Show Melon Exchange Rate Info */}
                            {park?.melon_exchange_rate && (
                                <div style={{
                                    marginTop: 6,
                                    padding: 6,
                                    background: '#e6f7ff',
                                    borderRadius: 4,
                                    border: '1px solid #91d5ff'
                                }}>
                                    <div style={{fontSize: 10, color: '#0050b3', textAlign: 'center'}}>
                                        💡 1 {currency} = {park?.melon_exchange_rate} Melon credits
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    <div style={{marginTop:8,}}>
                        <PurchaseButton 
                        final_price={amount?.total_amount} 
                        park={park} 
                        is_checkout 
                        payment_method={paymentMethod}
                        />
                    </div>
                </Space>
            </div>
        </>
    );
}

export default MobilePurchaseSummary;